import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, string_type, record_type, array_type, float64_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { Helpers_baseApiUrl, Helpers_withSecureHeader } from "./Api.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Thoth.Fetch.3.0.1/../Fable.Promise.3.2.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Thoth.Fetch.3.0.1/../Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/./Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Fetch.3.0.1/../Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Fetch.3.0.1/../Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";

export class Uttc extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Uttc_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Uttc", [], Uttc, () => [["0", array_type(float64_type)]]);
}

export class TurbineId extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function TurbineId_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.TurbineId", [], TurbineId, () => [["0", string_type]]);
}

export class Blddmg1 extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Blddmg1_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Blddmg1", [], Blddmg1, () => [["0", float64_type]]);
}

export class Blddmg1Tot extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Blddmg1Tot_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Blddmg1Tot", [], Blddmg1Tot, () => [["0", float64_type]]);
}

export class Blddmg2 extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Blddmg2_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Blddmg2", [], Blddmg2, () => [["0", float64_type]]);
}

export class Blddmg2Tot extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Blddmg2Tot_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Blddmg2Tot", [], Blddmg2Tot, () => [["0", float64_type]]);
}

export class Blddmg3 extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Blddmg3_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Blddmg3", [], Blddmg3, () => [["0", float64_type]]);
}

export class Blddmg3Tot extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Blddmg3Tot_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Blddmg3Tot", [], Blddmg3Tot, () => [["0", float64_type]]);
}

export class AdditionalInfo extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function AdditionalInfo_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.AdditionalInfo", [], AdditionalInfo, () => [["0", string_type]]);
}

export class Bld1Large extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld1Large_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld1Large", [], Bld1Large, () => [["0", float64_type]]);
}

export class Bld1Small extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld1Small_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld1Small", [], Bld1Small, () => [["0", float64_type]]);
}

export class Bld2Large extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld2Large_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld2Large", [], Bld2Large, () => [["0", float64_type]]);
}

export class Bld2Small extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld2Small_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld2Small", [], Bld2Small, () => [["0", float64_type]]);
}

export class Bld3Large extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld3Large_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld3Large", [], Bld3Large, () => [["0", float64_type]]);
}

export class Bld3Small extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld3Small_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld3Small", [], Bld3Small, () => [["0", float64_type]]);
}

export class Bld1Alarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld1Alarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld1Alarm", [], Bld1Alarm, () => [["0", float64_type]]);
}

export class Bld1TotalAlarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld1TotalAlarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld1TotalAlarm", [], Bld1TotalAlarm, () => [["0", float64_type]]);
}

export class Bld2Alarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld2Alarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld2Alarm", [], Bld2Alarm, () => [["0", float64_type]]);
}

export class Bld2TotalAlarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld2TotalAlarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld2TotalAlarm", [], Bld2TotalAlarm, () => [["0", float64_type]]);
}

export class Bld3Alarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld3Alarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld3Alarm", [], Bld3Alarm, () => [["0", float64_type]]);
}

export class Bld3TotalAlarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function Bld3TotalAlarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.Bld3TotalAlarm", [], Bld3TotalAlarm, () => [["0", float64_type]]);
}

export class DataInfo extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function DataInfo_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.DataInfo", [], DataInfo, () => [["0", string_type]]);
}

export class DataAlarm extends Record {
    constructor($0030) {
        super();
        this["0"] = $0030;
    }
}

export function DataAlarm_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.DataAlarm", [], DataAlarm, () => [["0", float64_type]]);
}

export class RootObject extends Record {
    constructor(uttc, turbine_id, blddmg_1, blddmg_1_tot, blddmg_2, blddmg_2_tot, blddmg_3, blddmg_3_tot, additional_info, bld1_large, bld1_small, bld2_large, bld2_small, bld3_large, bld3_small, bld_1_alarm, bld_1_total_alarm, bld_2_alarm, bld_2_total_alarm, bld_3_alarm, bld_3_total_alarm, data_info, data_alarm) {
        super();
        this.uttc = uttc;
        this.turbine_id = turbine_id;
        this.blddmg_1 = blddmg_1;
        this.blddmg_1_tot = blddmg_1_tot;
        this.blddmg_2 = blddmg_2;
        this.blddmg_2_tot = blddmg_2_tot;
        this.blddmg_3 = blddmg_3;
        this.blddmg_3_tot = blddmg_3_tot;
        this.additional_info = additional_info;
        this.bld1_large = bld1_large;
        this.bld1_small = bld1_small;
        this.bld2_large = bld2_large;
        this.bld2_small = bld2_small;
        this.bld3_large = bld3_large;
        this.bld3_small = bld3_small;
        this.bld_1_alarm = bld_1_alarm;
        this.bld_1_total_alarm = bld_1_total_alarm;
        this.bld_2_alarm = bld_2_alarm;
        this.bld_2_total_alarm = bld_2_total_alarm;
        this.bld_3_alarm = bld_3_alarm;
        this.bld_3_total_alarm = bld_3_total_alarm;
        this.data_info = data_info;
        this.data_alarm = data_alarm;
    }
}

export function RootObject_$reflection() {
    return record_type("EPM.App.Api.EntityDetails.RootObject", [], RootObject, () => [["uttc", Uttc_$reflection()], ["turbine_id", TurbineId_$reflection()], ["blddmg_1", Blddmg1_$reflection()], ["blddmg_1_tot", Blddmg1Tot_$reflection()], ["blddmg_2", Blddmg2_$reflection()], ["blddmg_2_tot", Blddmg2Tot_$reflection()], ["blddmg_3", Blddmg3_$reflection()], ["blddmg_3_tot", Blddmg3Tot_$reflection()], ["additional_info", AdditionalInfo_$reflection()], ["bld1_large", Bld1Large_$reflection()], ["bld1_small", Bld1Small_$reflection()], ["bld2_large", Bld2Large_$reflection()], ["bld2_small", Bld2Small_$reflection()], ["bld3_large", Bld3Large_$reflection()], ["bld3_small", Bld3Small_$reflection()], ["bld_1_alarm", Bld1Alarm_$reflection()], ["bld_1_total_alarm", Bld1TotalAlarm_$reflection()], ["bld_2_alarm", Bld2Alarm_$reflection()], ["bld_2_total_alarm", Bld2TotalAlarm_$reflection()], ["bld_3_alarm", Bld3Alarm_$reflection()], ["bld_3_total_alarm", Bld3TotalAlarm_$reflection()], ["data_info", DataInfo_$reflection()], ["data_alarm", DataAlarm_$reflection()]]);
}

const decoder = Auto_generateBoxedDecoder_Z6670B51(RootObject_$reflection(), undefined, undefined);

export function entityDetails(projectId, entityId) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helpers_withSecureHeader().then((_arg) => {
        let data_1, caseStrategy_1, extra_1;
        return ((data_1 = undefined, (caseStrategy_1 = undefined, (extra_1 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, _arg), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_1), unwrap(extra_1))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${Helpers_baseApiUrl}/${`projects/${projectId}/entities/auxiliary-data/${entityId}`}`, properties_3).then((_arg_1) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(RootObject_$reflection(), unwrap(caseStrategy_1), unwrap(extra_1))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.catch((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))));
    }))));
}

